import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { LISCase, LISDocument } from "pwapi";

import { scanBlock } from "app/actions/blockActions";
import { scanSpecimen } from "app/actions/specimenActions";
import { useAppDispatch } from "app/hooks";

import { useSelectedLabStation } from "./useSelectedLabStation";

const useGrossingOnScanCallbacks = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const selectedLabStation = useSelectedLabStation();

  const onScanBlock = useCallback(
    (id: number, navigateAfter: boolean = true) => {
      const promise = dispatch(
        scanBlock({
          id,
          parentLookupLabStationId: selectedLabStation.id,
        })
      );
      if (navigateAfter) {
        promise.then((response: LISCase) => {
          const documentId = response.documents[0].id;
          const specimenId = response.blocks.find(
            (b) => b.id === id
          )?.specimen_id;
          navigate(
            `/station/grossing/document/${documentId}/specimen/${specimenId}`
          );
          return response;
        });
      }
      return promise;
    },
    [selectedLabStation.id]
  );

  const onScanSpecimen = useCallback(
    (id: number, navigateAfter: boolean = true) => {
      const promise = dispatch(
        scanSpecimen({
          id,
          parentLookupLabStationId: selectedLabStation.id,
        })
      );
      if (navigateAfter) {
        promise.then((response: LISCase) => {
          const documentId = response.documents
            ?.filter(
              (d) => d.category === LISDocument.category.REQUISITION_FORM
              // TODO: better protections around bypassing non-uploaded req scans
              // For now, we will allow them to proceed
            )
            .at(0)?.id;
          navigate(`/station/grossing/document/${documentId}/specimen/${id}`);
          return response;
        });
      }
      return promise;
    },
    [selectedLabStation.id]
  );

  const onScanDocument = useCallback((id: number) => {
    navigate(`/station/grossing/document/${id}`);
  }, []);

  return {
    onScanBlock,
    onScanSpecimen,
    onScanDocument,
  };
};

export default useGrossingOnScanCallbacks;
